import React from "react";

export default function Terms() {
  return (
    <div style={{ padding: "1.5em" }}>
      <h2 style={{ textAlign: "center" }}>
        <b>TÉRMINOS Y CONDICIONES</b>
      </h2>
      <p style={{ marginTop: "2em" }}>Última actualización: 2023-01-13</p>
      <p>
        1. <b>Introducción</b>
      </p>
      <p>¡Bienvenido a Arblu ("Compañía", "nosotros", "la empresa")!</p>
      <p>
        Estos Términos de servicio ("Términos", "Términos de servicio") rigen su
        uso de nuestro sitio web ubicado en <b>https://www.arbluapp.com </b>y
        sus subdominios asociados (juntos o individualmente “Servicio”), junto
        con nuestra aplicación Arblu.
      </p>
      <p>
        Su acuerdo con nosotros incluye estos Términos y Condiciones
        (“Acuerdos”). Usted reconoce que ha leído y entendido estos Acuerdos, y
        acepta estar obligado por ellos.
      </p>
      <p>
        Si no está de acuerdo con (o no puede cumplir con) los Acuerdos,
        entonces usted no puede usar el Servicio, pero infórmenos enviando un
        correo electrónico a <b> ffernandez@arbluapp.com </b>
        para intentar buscar una solución. Estas Los términos se aplican a todos
        los visitantes, usuarios y otras personas que deseen acceder o utilizar
        Servicio
      </p>
      <p>
        2. <b>Comunicaciones</b>
      </p>
      <p>
        Al usar nuestro Servicio, acepta suscribirse a boletines, marketing o Al
        usar nuestro Servicio, acepta suscribirse a boletines, marketing o
        materiales promocionales y otra información que podamos enviar. Sin
        embargo, usted puede optar por no recibir ninguna o todas estas
        comunicaciones de nosotros por siguiendo el enlace para darse de baja o
        enviando un correo electrónico a ffernandez@arbluapp.com.
      </p>

      <p>
        3. <b>Concursos, Sorteos y Promociones</b>
      </p>
      <p>
        Cualquier concurso, sorteo u otras promociones (colectivamente,
        “Promociones”) disponibles a través del Servicio pueden regirse por
        reglas que son independientes de estos Términos de servicio. Si
        participas en alguna Promociones, por favor revisa las reglas aplicables
        así como nuestra Política de Privacidad Política. Si las reglas de una
        Promoción entran en conflicto con estos Términos de Servicio, se
        aplicarán las reglas de la promoción.
      </p>

      <p>
        4. <b>Contenido</b>
      </p>
      <p>
        El contenido que se encuentra en o a través de este Servicio es
        propiedad de Arblu o usado con permiso. Usted no puede distribuir,
        modificar, transmitir, reutilizar, descargar, volver a publicar, copiar
        o usar dicho Contenido, ya sea en su totalidad o en parte, con fines
        comerciales o para beneficio personal, sin expresa autorización previa
        por escrito de nuestra parte.
      </p>
      <p>
        5. <b>Usos prohibidos</b>
      </p>
      <p>
        Puede usar el Servicio solo para fines legales y de acuerdo con
        Términos. Usted acepta no utilizar el Servicio:
      </p>
      <p>
        0.1. De cualquier forma que viole cualquier ley nacional o internacional
        aplicable. ley o reglamento.
      </p>
      <p>
        0.2. Con el propósito de explotar, dañar o intentar explotar o dañar a
        los menores de cualquier manera exponiéndolos a contenido inapropiado o
        de lo contrario.
      </p>
      <p>
        0.3. Transmitir o procurar el envío de cualquier tipo de publicidad o
        material promocional, incluido cualquier "correo basura", "carta en
        cadena", "spam" o cualquier otra solicitud similar.
      </p>
      <p>
        0.4. Suplantar o intentar suplantar a la Compañía, una Compañía
        empleado, otro usuario o cualquier otra persona o entidad.
      </p>
      <p>
        0.5. De cualquier manera que infrinja los derechos de otros, o de
        cualquier manera sea ilegal, amenazante, fraudulento o dañino, o esté
        relacionado con cualquier propósito o actividad ilícita, ilegal,
        fraudulenta o dañina.
      </p>
      <p>
        0.6. Participar en cualquier otra conducta que restrinja o inhiba el uso
        o disfrute del Servicio, o que, según lo determinemos, pueda dañar u
        Ofender a la Compañía o a los usuarios del Servicio o exponerlos a
        responsabilidad.
      </p>
      <p>Además, acepta no:</p>
      <p>
        0.1. Usar el Servicio de cualquier manera que pueda inhabilitar,
        sobrecargar, dañar, o dañar el Servicio o interferir con el uso del
        Servicio por parte de cualquier otra parte, incluida su capacidad para
        participar en actividades en tiempo real a través de Servicio.
      </p>
      <p>
        0.2. Usar cualquier robot, araña u otro dispositivo, proceso o medio
        automático para acceder al Servicio para cualquier propósito, incluido
        el seguimiento o la copia de cualquier del material en Servicio.
      </p>
      <p>
        0.3. Usar cualquier proceso manual para monitorear o copiar cualquiera
        de los materiales en Servicio o para cualquier otro propósito no
        autorizado sin nuestro previo escrito consentir.
      </p>
      <p>
        0.4. Utilizar cualquier dispositivo, software o rutina que interfiera
        con el correcto funcionamiento del Servicio.
      </p>
      <p>
        0.5. Introducir virus, troyanos, gusanos, bombas lógicas u otros
        material malicioso o tecnológicamente dañino.
      </p>
      <p>
        0.6. Intentar obtener acceso no autorizado, interferir, dañar o
        interrumpir cualquier parte del Servicio, el servidor en el que se
        almacena el Servicio, o cualquier servidor, computadora o base de datos
        conectada al Servicio.
      </p>
      <p>
        0.7. Servicio de ataque a través de un ataque de denegación de servicio
        o un ataque distribuido ataque de denegación de servicio.
      </p>
      <p>
        0,8. Tomar cualquier acción que pueda dañar o falsear la calificación de
        la Compañía.
      </p>
      <p>
        0.9. De lo contrario, intente interferir con el correcto funcionamiento
        del Servicio.
      </p>
      <p>
        6. <b>Análisis</b>
      </p>
      <p>
        Podemos utilizar proveedores de servicios de terceros para monitorear y
        analizar el uso de nuestro Servicio.
      </p>
      <p>
        7. <b>Prohibido el uso por parte de menores</b>
      </p>
      <p>
        El servicio está destinado únicamente para el acceso y uso de personas
        al menos dieciocho (18) años. Al acceder o utilizar el Servicio, usted
        garantiza y declara que tiene al menos dieciocho (18) años de edad y con
        la plena autoridad, derecho y capacidad para celebrar este acuerdo y
        Cumplir con todos los términos y condiciones de los Términos. si no
        estas en menos dieciocho (18) años, tiene prohibido tanto el acceso y
        uso del Servicio.
      </p>
      <p>
        8. <b>Cuentas</b>
      </p>
      <p>
        Cuando crea una cuenta con nosotros, garantiza que está por encima del
        mayor de 18 años, y que la información que nos proporcionas es veraz,
        completa y vigente en todo momento. Inexacto, incompleto u obsoleto
        información puede resultar en la terminación inmediata de su cuenta en
        Servicio.
      </p>
      <p>
        Usted es responsable de mantener la confidencialidad de su cuenta y
        contraseña, incluyendo pero no limitado a la restricción de acceso a su
        computadora y/o cuenta. Usted acepta aceptar la responsabilidad por
        cualquier y todas las actividades o acciones que ocurran bajo su cuenta
        y/o contraseña, ya sea que su contraseña sea con nuestro Servicio o con
        un tercero Servicio. Debe notificarnos inmediatamente al darse cuenta de
        cualquier violación de la seguridad o uso no autorizado de su cuenta.
      </p>
      <p>
        No puede utilizar como nombre de usuario el nombre de otra persona o
        entidad o que no está legalmente disponible para su uso, un nombre o
        marca registrada que es sujeto a cualquier derecho de otra persona o
        entidad que no sea usted, sin la debida autorización. No puede utilizar
        como nombre de usuario ningún nombre que sea ofensivo, vulgar u obsceno.
      </p>
      <p>
        Nos reservamos el derecho de rechazar el servicio, cancelar cuentas,
        eliminar o editar contenido o cancelar pedidos a nuestro exclusivo
        criterio.
      </p>
      <p>
        9. <b>Propiedad intelectual</b>
      </p>
      <p>
        Servicio y su contenido original (excluyendo el Contenido proporcionado
        por los usuarios), características y funcionalidades son y seguirán
        siendo propiedad exclusiva de Arblu App y sus licenciantes. El servicio
        está protegido por derechos de autor, marca comercial y otras leyes de
        países extranjeros. Nuestras marcas pueden no debe utilizarse en
        relación con ningún producto o servicio sin la previa consentimiento por
        escrito de la aplicación de reacción.
      </p>
      <p>
        10. <b>Política de derechos de autor</b>
      </p>
      <p>
        Respetamos los derechos de propiedad intelectual de otros. es nuestra
        politica para responder a cualquier reclamo de que el Contenido
        publicado en el Servicio infringe los derechos de autor u otros derechos
        de propiedad intelectual ("Infracción") de cualquier persona o entidad.
      </p>
      <p>
        Si es propietario de derechos de autor, o está autorizado en nombre de
        uno, y cree que el trabajo con derechos de autor ha sido copiado de una
        manera que constituye una infracción de derechos de autor, envíe su
        reclamo por correo electrónico a ffernandez@arbluapp.com, con el asunto:
        “Copyright Infracción” e incluya en su reclamación una descripción
        detallada de la supuesta infracción como se detalla a continuación, en
        "Aviso y procedimiento de DMCA para reclamos por infracción de derechos
        de autor”
      </p>
      <p>
        Es posible que se le haga responsable de los daños (incluidos los costos
        y los gastos de honorarios de los abogados). por declaraciones falsas o
        reclamos de mala fe sobre la infracción de cualquier Contenido
        encontrado en y/o a través del Servicio en sus derechos de autor.
      </p>
      <p>
        11.{" "}
        <b>
          Aviso y procedimiento de la DMCA para reclamaciones por infracción de
          derechos de autor
        </b>
      </p>
      <p>
        Puede enviar una notificación de conformidad con Digital Millennium Ley
        de derechos de autor (DMCA) proporcionando a nuestro agente de derechos
        de autor la siguiente información por escrito (ver 17 U.S.C 512(c)(3)
        para más detalles):
      </p>
      <p>
        0.1. una firma electrónica o física de la persona autorizada para actuar
        en nombre del propietario del interés de los derechos de autor;
      </p>
      <p>
        0.2. una descripción del trabajo protegido por derechos de autor que
        afirma que ha sido infringido, incluida la URL (es decir, la dirección
        de la página web) de la ubicación donde existe el trabajo protegido por
        derechos de autor o una copia del trabajo protegido por derechos de
        autor;
      </p>
      <p>
        0.3. identificación de la URL u otra ubicación específica en el Servicio
        dónde se encuentra el material que usted afirma que está infringiendo;
      </p>
      <p>
        0,4. su dirección, número de teléfono y dirección de correo electrónico;
      </p>
      <p>
        0.5. una declaración suya de que cree de buena fe que el el uso en
        disputa no está autorizado por el propietario de los derechos de autor,
        su agente o el ley;
      </p>
      <p>
        0.6. una declaración suya, hecha bajo pena de perjurio, de que lo
        anterior la información en su aviso es precisa y que usted es el
        propietario de los derechos de autor propietario o autorizado para
        actuar en nombre del propietario de los derechos de autor.
      </p>
      <p>
        Puede ponerse en contacto con nuestro agente de derechos de autor por
        correo electrónico en ffernandez@arbluapp.com.
      </p>
      <p>
        12. <b>Informe de errores y comentarios</b>
      </p>
      <p>
        Puede proporcionarnos directamente a ffernandez@arbluapp.com o a través
        de sitios y herramientas de terceros con información y comentarios sobre
        errores, sugerencias de mejora, ideas, problemas, quejas y otros asuntos
        relacionados con nuestro Servicio ("Comentarios"). Tu reconoces y acepta
        que: (i) no conservará, adquirirá ni hará valer ninguna propiedad
        intelectual derecho de propiedad u otro derecho, título o interés en los
        Comentarios; (ii) la Empresa puede tener ideas de desarrollo similares a
        los Comentarios; (iii) Los comentarios no contienen información
        confidencial o de propiedad información de usted o de cualquier tercero;
        y (iv) la Compañía no está bajo cualquier obligación de confidencialidad
        con respecto a los Comentarios. En el caso de que la transferencia de la
        propiedad al Feedback no sea posible debido a las leyes obligatorias
        aplicables, otorga a la Compañía y a sus afiliados una exclusiva,
        transferible, irrevocable, gratuita, sublicenciable, derecho ilimitado y
        perpetuo de uso (incluyendo copiar, modificar, crear obras derivadas,
        publicar, distribuir y comercializar) Comentarios en cualquier manera y
        para cualquier propósito.
      </p>
      <p>
        13. <b>Enlaces a otros sitios web</b>
      </p>
      <p>
        Nuestro Servicio puede contener enlaces a sitios web o servicios de
        terceros que no son propiedad ni están controlados por Arblu App.
      </p>
      <p>
        Arblu no tiene control ni asume ninguna responsabilidad por el
        contenido, políticas de privacidad o prácticas de sitios web de terceros
        o servicios. No garantizamos las ofertas de ninguno de estos
        entidades/individuos o sus sitios web.
      </p>
      <p>
        USTED RECONOCE Y ACEPTA QUE LA EMPRESA NO SERÁ RESPONSABLE O
        RESPONSABLE, DIRECTA O INDIRECTAMENTE, POR CUALQUIER DAÑO O PÉRDIDA
        CAUSADA O ALEGADA SER CAUSADO POR O EN CONEXIÓN CON EL USO O LA
        CONFIANZA EN CUALQUIERA DE DICHOS CONTENIDO, BIENES O SERVICIOS
        DISPONIBLES EN O A TRAVÉS DE DICHO TERCERO SITIOS WEB O SERVICIOS.
      </p>
      <p>
        LE RECOMENDAMOS ENCARECIDAMENTE LEER LOS TÉRMINOS DEL SERVICIO Y LAS
        POLÍTICAS DE PRIVACIDAD DE CUALQUIER SITIO WEB O SERVICIOS DE TERCEROS
        QUE USTED VISITE.
      </p>
      <p>
        14. <b>Renuncia de garantía</b>
      </p>
      <p>
        ESTOS SERVICIOS SON PROPORCIONADOS POR LA EMPRESA "TAL CUAL" Y "SEGÚN
        DISPONIBILIDAD" BASE. LA COMPAÑÍA NO HACE REPRESENTACIONES NI GARANTÍAS
        DE NINGÚN TIPO, EXPRESA O IMPLÍCITA, EN CUANTO AL FUNCIONAMIENTO DE SUS
        SERVICIOS, O LA INFORMACIÓN, CONTENIDO O MATERIALES INCLUIDOS EN EL
        MISMO. USTED ACEPTA EXPRESAMENTE QUE SU USO DE ESTOS SERVICIOS, SU
        CONTENIDO Y CUALQUIER SERVICIO O LOS ARTÍCULOS OBTENIDOS DE NOSOTROS ES
        BAJO SU PROPIO RIESGO.
      </p>
      <p>
        NI LA COMPAÑÍA NI NINGUNA PERSONA ASOCIADA CON LA COMPAÑÍA REALIZA
        NINGÚN GARANTÍA O DECLARACIÓN CON RESPECTO A LA INTEGRIDAD, SEGURIDAD,
        FIABILIDAD, CALIDAD, EXACTITUD O DISPONIBILIDAD DE LOS SERVICIOS. SIN
        QUE LIMITANDO LO ANTERIOR, NI LA EMPRESA NI NINGUNA PERSONA ASOCIADA CON
        LA COMPAÑÍA REPRESENTA O GARANTIZA QUE LOS SERVICIOS, SU CONTENIDO O
        CUALQUIER LOS SERVICIOS O ARTÍCULOS OBTENIDOS A TRAVÉS DE LOS SERVICIOS
        SERÁN EXACTOS, CONFIABLE, LIBRE DE ERRORES O ININTERRUMPIDO, QUE LOS
        DEFECTOS SERÁN CORREGIDOS, QUE LOS SERVICIOS O EL SERVIDOR QUE LO PONE A
        DISPOSICIÓN ESTÁN LIBRES DE VIRUS U OTROS COMPONENTES DAÑINOS O QUE LOS
        SERVICIOS O CUALQUIER SERVICIO O LOS ARTÍCULOS OBTENIDOS A TRAVÉS DE LOS
        SERVICIOS SATISFACERÁN SUS NECESIDADES O EXPECTATIVAS.
      </p>
      <p>
        LA COMPAÑÍA RENUNCIA A TODA GARANTÍA DE CUALQUIER TIPO, YA SEA EXPRESA O
        IMPLÍCITO, ESTATUTARIO O DE OTRO MODO, INCLUYENDO PERO NO LIMITADO A
        CUALQUIER GARANTÍAS DE COMERCIABILIDAD, NO VIOLACIÓN E IDONEIDAD PARA
        PROPÓSITO PARTICULAR.
      </p>
      <p>
        LO ANTERIOR NO AFECTA NINGUNA GARANTÍA QUE NO SE PUEDE EXCLUIR O
        LIMITADO BAJO LA LEY APLICABLE.
      </p>
      <p>
        15. <b>Limitación de responsabilidad</b>
      </p>
      <p>
        A EXCEPCIÓN DE LO PROHIBIDO POR LA LEY, USTED NOS RETENDRÁ A NOSOTROS Y
        A NUESTROS FUNCIONARIOS, DIRECTORES, EMPLEADOS Y AGENTES DE
        RESPONSABILIDAD POR CUALQUIER INDIRECTO, PUNITIVO, DAÑO ESPECIAL,
        INCIDENTAL O CONSECUENTE, COMO SURJA (INCLUYENDO HONORARIOS DE ABOGADOS
        Y TODOS LOS COSTOS Y GASTOS RELACIONADOS DE LITIGIO Y ARBITRAJE, O EN
        JUICIO O EN APELACIÓN, EN SU CASO, YA SEA O NO SE INSTITUYA LITIGIO NI
        ARBITRAJE), YA SEA EN UNA ACCIÓN DE CONTRATO, NEGLIGENCIA U OTRA ACCIÓN
        DE AGRAVIO, O QUE SURJA DE O EN CONEXIÓN CON ESTE ACUERDO, INCLUYENDO
        SIN LIMITACIÓN CUALQUIER RECLAMACIÓN POR LESIONES PERSONALES O DAÑOS A
        LA PROPIEDAD, DERIVADOS DE ESTE ACUERDO Y CUALQUIER VIOLACIÓN POR SU
        PARTE DE CUALQUIER LEY FEDERAL, ESTATAL O LOCAL, ESTATUTOS, NORMAS O
        REGLAMENTOS, INCLUSO SI LA COMPAÑÍA HA SIDO PREVIAMENTE ADVERTIDA DE LA
        POSIBILIDAD DE CUENTOS DAÑOS. EXCEPTO LO PROHIBIDO POR LA LEY, SI EXISTE
        LA RESPONSABILIDAD ENCONTRADA POR PARTE DE LA EMPRESA, ESTARÁ LIMITADA A
        LA CANTIDAD PAGADO POR LOS PRODUCTOS Y/O SERVICIOS, Y BAJO NINGUNA
        CIRCUNSTANCIA HAY DAÑOS CONSECUENCIALES O PUNITIVOS. ALGUNOS ESTADOS NO
        PERMITEN LA EXCLUSIÓN O LIMITACIÓN DE PUNITIVOS, INCIDENTALES O
        CONSECUENTES DAÑOS, POR LO QUE LA LIMITACIÓN O EXCLUSIÓN PREVIA PUEDE NO
        SER APLICABLE A USTED.
      </p>
      <p>
        16. <b>Terminación</b>
      </p>
      <p>
        Podemos cancelar o suspender su cuenta y prohibir el acceso al Servicio
        inmediatamente, sin previo aviso ni responsabilidad, bajo nuestro
        discreción exclusiva, por cualquier motivo y sin limitación, incluyendo
        pero no limitado a un incumplimiento de los Términos.
      </p>
      <p>
        Si desea cancelar su cuenta, simplemente puede dejar de usar Servicio.
      </p>
      <p>
        Todas las disposiciones de los Términos que, por su naturaleza, deben
        sobrevivir a la rescisión sobrevivirá a la rescisión, incluida, entre
        otras, la propiedad disposiciones, renuncias de garantía, indemnización
        y límites de responsabilidad.
      </p>
      <p>
        17. <b>Legislación aplicable</b>
      </p>
      <p>
        Estos Términos se regirán e interpretarán de conformidad con las leyes
        de la República de Chile,, cuya ley aplicable se aplica al contrato sin
        tener en cuenta sus disposiciones sobre conflicto de leyes.
      </p>
      <p>
        Nuestra falla en hacer cumplir cualquier derecho o disposición de estos
        Los términos no fueron considerados una renuncia a esos derechos. si
        alguna disposición de estos Términos es declarado inválido o inaplicable
        por un tribunal, las disposiciones restantes de estos términos mejorarán
        en vigor. Estos Términos constituyen la totalidad de acuerdo entre
        nosotros con respecto a nuestro Servicio y reemplaza y reemplaza
        cualquier acuerdo previo que pudimos haber tenido entre nosotros con
        respecto al Servicio.
      </p>
      <p>
        18. <b>Cambios en el servicio</b>
      </p>
      <p>
        Nos reservamos el derecho de retirar o modificar nuestro Servicio, y
        cualquier servicio o material que proporcionamos a través del Servicio,
        a nuestro exclusivo criterio sin darse cuenta. No seremos responsables
        si, por cualquier motivo, la totalidad o parte de El servicio no está
        disponible en ningún momento ni durante ningún período. De vez en
        cuando, podemos restringir el acceso a algunas partes del Servicio, o al
        Servicio completo, a los usuarios, incluidos los usuarios registrados.
      </p>
      <p>
        19. <b>Modificaciones a los Términos</b>
      </p>
      <p>
        Podemos modificar los Términos en cualquier momento publicando los
        términos modificados en este sitio. Es su responsabilidad revisar estos
        Términos periódicamente.
      </p>
      <p>
        Su uso continuado de la Plataforma luego de la publicación de Términos
        significa que usted acepta y está de acuerdo con los cambios. Usted es
        esperado para revisar esta página con frecuencia para estar al tanto de
        cualquier cambio, ya que son vinculantes para usted.
      </p>
      <p>
        Al continuar accediendo o usando nuestro Servicio después de que
        cualquier revisión sea efectivo, usted acepta estar sujeto a los
        términos revisados. Si no lo hace acepta los nuevos términos, ya no está
        autorizado a utilizar el Servicio.
      </p>
      <p>
        20. <b>Renuncia y Divisibilidad</b>
      </p>
      <p>
        Ninguna renuncia por parte de la Compañía a cualquier término o
        condición establecida en los Términos se considerará una renuncia
        adicional o continua de dicho término o condición o una renuncia a
        cualquier otro término o condición, y cualquier incumplimiento por parte
        de la Compañía de hacer valer un derecho o disposición bajo los Términos
        no constituirá una renuncia a tal derecho o disposición.
      </p>
      <p>
        Si cualquier disposición de los Términos es sostenida por un tribunal u
        otro tribunal de jurisdicción competente sea inválida, ilegal o
        inaplicable para cualquier razón, dicha disposición será eliminada o
        limitada al mínimo medida tal que las disposiciones restantes de los
        Términos continuarán en su totalidad fuerza y efecto.
      </p>
      <p>
        21. <b>Reconocimiento</b>
      </p>
      <p>
        AL UTILIZAR EL SERVICIO U OTROS SERVICIOS PROPORCIONADOS POR NOSOTROS,
        USTED RECONOCE QUE USTED HA LEÍDO ESTOS TÉRMINOS DE SERVICIO Y ACEPTA
        ESTAR OBLIGADO POR ELLOS.
      </p>
      <p>
        22. <b>Contáctenos</b>
      </p>
      <p>
        Envíe sus opiniones, comentarios, solicitudes de soporte técnico por
        correo electrónico: <b>ffernandez@arbluapp.com</b>.
      </p>
    </div>
  );
}
